import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE } from '../apiConfig';

export const useCalculatorData = (calculatorId) => {
  const [meta, setMeta] = useState({ navbars: [], groups: [], assets: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [navRes, groupRes, assetRes] = await Promise.all([
          axios.get(`${API_BASE}/api/assets/navbars`),
          axios.get(`${API_BASE}/api/assets/asset-groups`),
          axios.get(`${API_BASE}/api/assets/admin/all`)
        ]);

        // Ֆիլտրում ենք տվյալները միայն տվյալ հաշվիչի համար
        setMeta({
          navbars: navRes.data.filter(n => n.calculator_id === calculatorId),
          groups: groupRes.data.filter(g => g.calculator_id === calculatorId),
          assets: assetRes.data.data // Assets-ները սովորաբար ֆիլտրվում են ըստ խմբերի
        });
      } catch (err) {
        console.error("Data fetch error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [calculatorId]);

  return { meta, loading };
};